import { render, staticRenderFns } from "./imprimirorden.vue?vue&type=template&id=a00e5e4a"
import script from "./imprimirorden.vue?vue&type=script&lang=js"
export * from "./imprimirorden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports